"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketManagerProvider = SocketManagerProvider;
exports.useSocketManager = useSocketManager;
exports.useLobbyConnection = useLobbyConnection;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const SocketManager_1 = require("./SocketManager");
const NetworkingContext = (0, react_1.createContext)(null);
function SocketManagerProvider({ children, gameConnectionHolder, lobbyConnectionHolder, accountIdHolder, socketManagerHolder, }) {
    const dispatch = (0, react_redux_1.useDispatch)();
    const ref = (0, react_1.useRef)(null);
    if (ref.current === null) {
        const socketManager = new SocketManager_1.SocketManager(dispatch, gameConnectionHolder, lobbyConnectionHolder, accountIdHolder);
        socketManagerHolder.set(socketManager);
        ref.current = {
            socketManager,
            gameConnectionHolder,
            lobbyConnectionHolder,
        };
    }
    return (react_1.default.createElement(NetworkingContext.Provider, { value: ref.current }, children));
}
function useNetworking() {
    const context = (0, react_1.useContext)(NetworkingContext);
    if (!context) {
        throw new Error("useSocketManager / useLobbyConnection must be used within a SocketManagerProvider");
    }
    return context;
}
function useSocketManager() {
    return useNetworking().socketManager;
}
function useLobbyConnection() {
    const { lobbyConnectionHolder } = useNetworking();
    (0, react_1.useSyncExternalStore)(lobbyConnectionHolder.subscribe, lobbyConnectionHolder.getSnapshot);
    return lobbyConnectionHolder.peek();
}
